import { Breadcrumbs } from 'components/Common/Common';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import { My_CASELOAD } from 'config/paths';
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useGetAchievementDataQuery } from 'store/services/myCaseload';
import Hummingbird from "../../../Assets/images/Hummingbird.png"
import Lucifer from "../../../Assets/images/Lucifer.png"
import Rivoli from "../../../Assets/images/Rivoli.png"
import Xanthus from "../../../Assets/images/Xanthus.png"
import BlankBadge from "../../../Assets/images/blankbadge.png"
import { BadgeLockIcon } from 'Assets/icons/v2';
import { useGetMyAchievementBadgesQuery, useGetMyAchievementQuery } from 'store/services/achievements';
import { useLazyGetFileUrlQuery } from 'store/services/utility';

function MyAchievements() {
  const { data: achievementData, isLoading } = useGetMyAchievementQuery()
  const { data: achievementBadges } = useGetMyAchievementBadgesQuery()
  console.log("achievementData", achievementBadges)

  const BADGES = [
    {
      name: "Hummingbird",
      stars: 1,
      colorImg: Hummingbird,
      blankImg: BlankBadge,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna."
    },
    {
      name: "Lucifer",
      stars: 6,
      colorImg: Lucifer,
      blankImg: BlankBadge,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna."
    },
    {
      name: "Rivoli",
      stars: 9,
      colorImg: Rivoli,
      blankImg: BlankBadge,
      description: "Keep going you’re almost there!"
    },
    // {
    //   name: "Xanthus",
    //   stars: 12,
    //   colorImg: Xanthus,
    //   blankImg: BlankBadge,
    //   description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna."
    // },
    {
      name: "Costa",
      stars: 15,
      colorImg: "/assets/badges/costa.png",
      blankImg: BlankBadge,
      description: "Not earned yet!"
    },
    {
      name: "Rufus",
      stars: 20,
      colorImg: "/assets/badges/rufus.png",
      blankImg: BlankBadge,
      description: "Not earned yet!"
    },
  ];

  const userStars = achievementData?.achievements?.totalTasks || 0;


  return (
    <div>
      <section
        className='client position-relative py-4 px-2 min-vh-100'
        style={{ background: "#3DA0AA0D" }}
      >
        <Container fluid>



          {isLoading ? (
            <div style={{ height: "200px" }}>
              <LoadingIndicator />
            </div>
          ) : (
            <Row>
              <Col  >
                <Breadcrumbs
                  items={[
                    { label: 'My Caseload', path: My_CASELOAD },
                    { label: 'My Achievements', path: "" }
                  ]}
                  style={{ fontSize: "14px" }}
                />

                <div className='mt-5'>
                  <h2 className="achievement-label">My Achievements</h2>

                  <div className="mt-4 bg-white p-4 shadow rounded-3 col-lg-10">
                    <Row className="justify-content-center">
                      <Col xs={3} className="d-flex flex-column gap-2">
                        <p className="caseload-label text-center mb-3">
                          TASKS COMPLETED <br /> THIS YEAR
                        </p>
                        <p className="caseload-num text-center mb-0">{achievementData?.achievements?.totalCompletedTasksThisYear}</p>
                      </Col>

                      <Col xs={3} className="d-flex flex-column gap-2">
                        <p className="caseload-label text-center mb-3">
                          ALL TIME <br /> TASKS COMPLETED
                        </p>
                        <p className="caseload-num text-center mb-0">{achievementData?.achievements?.totalTasks}</p>

                      </Col>

                      <Col xs={3} className="d-flex flex-column justify-content-between gap-2">
                        <p className="caseload-label text-center mb-3">
                          YEARS OF SERVICE
                        </p>
                        <p className="caseload-num text-center mb-0">{achievementData?.achievements?.totalClient}</p>

                      </Col>
                    </Row>

                    <div className="mt-5 col-lg-10">
                      <h4 className="caseload-label mb-2">BADGES EARNED</h4>

                      <p className="caseload-label fw-semibold" style={{ fontSize: "15px", color: "#071E3E", lineHeight: "22px" }}>
                        Hummingbirds are our way of keeping track of your progress.
                        Each hummingbird is unique and interesting — just like the
                        tasks you’ll be completing with your students.
                      </p>

                      <p className="caseload-head" style={{ fontSize: "15px", color: "#071E3E" }}>
                        Complete tasks to earn stars. The more stars you get each year,
                        the more hummingbird badges you will earn. Your badge status
                        will reset every school year, but you’ll never lose your total
                        star count (all time tasks completed). Have fun!
                      </p>

                    </div>
                    <Row className="mt-5 justify-content-center">
                      {achievementBadges?.map((badge, index) => {
                        const isEarned = Boolean(badge?.unlocked);
                        console.log("isEarned", isEarned)

                        return (
                          <Col key={index} xs={12} md={4} className="text-center mb-5">

                            {/* Badge */}
                            <div className="position-relative d-flex justify-content-center">
                              <img
                                src={isEarned ? badge?.icon_url : BlankBadge}
                                alt={badge.name}
                                style={{ width: "133px", height: "142px" }}
                              />

                              <div
                                className="position-absolute badge-name"
                                style={{
                                  background: isEarned ? "#9ECFD4" : "#DCE5F3"
                                }}
                              >
                                {isEarned ? badge.badge_name : <BadgeLockIcon />}
                              </div>
                            </div>

                            {/* Stars */}
                            <div className="mt-4">
                              <p className="badge-stars mb-2" style={{ minHeight: "20px" }}>
                                {
                                  isEarned && <>⭐ {badge.min_stars} {badge.min_stars === 1 ? "star" : "stars"}</>
                                }
                              </p>


                              {/* Description */}
                              <p className={`badge-desc ${!isEarned && "fst-italic"}`}>
                                {isEarned ? badge?.description : "Not earned yet!"}
                              </p>
                            </div>

                          </Col>
                        );
                      })}
                    </Row>

                    <div className="p-3 rounded-3 d-flex justify-content-center" style={{ background: "#315D991A" }}>
                      <div className="col-lg-8">
                        <h3 className='achievement-label text-center' style={{ color: "#315D99" }}>Congratulations, you’re a Superstar!</h3>
                        <p className={`achievement-desc text-center `}>You’ve earned the highest level of achievements in Trackabilities. Keep working on those tasks to earn more stars and you might see morebadges appear here soon.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

          )}

        </Container>
      </section>
    </div>
  )
}

export default MyAchievements